import { createAction } from "@reduxjs/toolkit";

export const azzeraMonitoraggio = createAction("AZZERA_MONITORAGGIO@tracking");

export const fetchMonitoraggio = createAction("FETCH_MONITORAGGIO@tracking");

export const fetchMonitoraggioSuccess = createAction("FETCH_MONITORAGGIO_SUCCESS@tracking");

export const fetchMonitoraggioFailed = createAction("FETCH_MONITORAGGIO_FAILED@tracking");

export const fetchUpdateMonitoraggio = createAction("FETCH_UPDATE_MONITORAGGIO@tracking");

export const fetchUpdateMonitoraggioSuccess = createAction("FETCH_UPDATE_MONITORAGGIO_SUCCESS@tracking");

export const fetchUpdateMonitoraggioFailed = createAction("FETCH_UPDATE_MONITORAGGIO_FAILED@tracking");

export const setEncounterNotification = createAction("SET_ENCOUNTER_NOTIFICATION@tracking");

export const resetEncounterNotification = createAction("RESET_ENCOUNTER_NOTIFICATION@tracking");

export const closeEncounterNotification = createAction("CLOSE_ENCOUNTER_NOTIFICATION@tracking");

export const setFailedEncounterCalls = createAction("SET_FAILED_ENCOUNTER_CALLS@tracking");
